import type { TechnologyCost } from '@netpurpose/types'
import type { AxiosInstances } from '../../client'
import {
  type BackendTechnologyCost,
  formatPartialTechnologyCost,
  parseTechnologyCost,
  technologyCostReverseFieldMap,
} from '../datapoint'
import { SimpleAbstractModelApi } from '../SimpleAbstractModelApi'

export default class TechnologyCostApi extends SimpleAbstractModelApi<
  BackendTechnologyCost,
  TechnologyCost
> {
  endpoint = '/costs'
  modelFormatter = formatPartialTechnologyCost
  reverseFieldMap = technologyCostReverseFieldMap

  constructor(axiosInstances: AxiosInstances) {
    super(axiosInstances, parseTechnologyCost)
  }
}
